import React from 'react';
import { useApp } from '../context/AppContext';
import { ChevronRight, Trash, Database, Download, Info, FileText, Shield } from 'lucide-react';

const AppSettingsScreen = () => {
  const { setCurrentScreen, resetScanData } = useApp();

  const handleClearCache = () => {
    if (confirm('Clear all cached scan data?')) {
      sessionStorage.clear();
      alert('Cache cleared successfully');
    }
  };

  const handleClearHistory = () => {
    if (confirm('Clear all scan history? This cannot be undone.')) {
      // TODO: Clear scan history from backend
      alert('History cleared');
    }
  };

  const handleExportData = () => {
    alert('Data export feature coming soon!');
  };

  const settingsItems = [
    { 
      label: 'Clear Cache', 
      icon: Trash, 
      action: handleClearCache,
      desc: 'Clear stored scan data'
    },
    { 
      label: 'Clear History', 
      icon: Database, 
      action: handleClearHistory,
      desc: 'Remove all past scans'
    },
    { 
      label: 'Data Usage', 
      icon: Database, 
      action: () => alert('Storage: ' + Math.round((JSON.stringify(sessionStorage).length / 1024)) + ' KB used'),
      desc: 'View storage usage'
    },
    { 
      label: 'Export Data', 
      icon: Download, 
      action: handleExportData,
      desc: 'Download your data'
    },
    { 
      label: 'About Atelia', 
      icon: Info, 
      action: () => alert('Atelia.AI v1.0\n\nFashion Intelligence Platform\n\n© 2026 Atelia.AI'),
      desc: 'App version & info'
    },
    { 
      label: 'Privacy Policy', 
      icon: Shield, 
      action: () => alert('Privacy Policy\n\nYour data is encrypted and never shared with third parties.'),
      desc: 'How we handle data'
    },
    { 
      label: 'Terms & Conditions', 
      icon: FileText, 
      action: () => alert('Terms & Conditions\n\nBy using Atelia.AI, you agree to our terms of service.'),
      desc: 'Legal terms'
    }
  ];

  return (
    <div className="min-h-screen bg-white pb-24">
      <div className="px-6 pt-6 pb-4 flex items-center gap-4 border-b border-black/10">
        <button
          onClick={() => setCurrentScreen('profile')}
          className="w-10 h-10 bg-black/5 rounded-xl flex items-center justify-center hover:bg-black/10 transition-all flex-shrink-0"
        >
          <ChevronRight size={18} className="text-black rotate-180" />
        </button>
        <button onClick={() => setActiveTab("home")} className="hover:opacity-80 transition-opacity"><img src="/logos/logo-black.jpg" alt="ATELIA" className="h-16 w-auto object-contain" /></button>
      </div>

      <div className="px-6 pt-6 pb-4">
        <p className="text-xs uppercase tracking-wide text-black/55 mb-2 font-bold">APPLICATION</p>
        <h1 className="text-2xl font-bold text-black uppercase tracking-wide">App Settings</h1>
      </div>

      <div className="px-6 space-y-2">
        {settingsItems.map((item, i) => {
          const Icon = item.icon;
          return (
            <button
              key={i}
              onClick={item.action}
              className="w-full bg-white border border-black/12 rounded-xl p-4 flex items-center justify-between hover:bg-black/5"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-black/5 rounded-xl flex items-center justify-center">
                  <Icon size={18} className="text-black" />
                </div>
                <div className="text-left">
                  <p className="text-sm font-bold text-black uppercase">{item.label}</p>
                  <p className="text-xs text-black/55 mt-0.5">{item.desc}</p>
                </div>
              </div>
              <ChevronRight size={16} className="text-black/30" />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default AppSettingsScreen;